module.exports = __webpack_public_path__ + "media/Video 120.f86c276b.mp4";